module.exports = __webpack_public_path__ + "static/media/chair3left.0b51e67a.png";